import { createSlice } from '@reduxjs/toolkit';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from 'store';

import { EnteredPrize, PrizeRequestParams } from '../types/prize.d';

export type ErrorResponse = {
  message: string;
};

const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';

export const prizeAPI = createApi({
  reducerPath: 'prizeAPI',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // ここにカスタムヘッダーを追加します
      // 現在の状態にアクセスします
      const state = getState() as RootState;
      // 状態からユーザートークンを取得します
      const userToken = state.liffUser.userToken;
      headers.set('Content-Type', 'application/json');
      headers.set('Authorization', `Bearer ${userToken}`);
      return headers;
    },
  }),
  tagTypes: ['Prize'],
  endpoints: builder => ({
    getPrize: builder.query<EnteredPrize, void>({
      query: () => ({
        url: `/prize`,
        method: 'GET',
      }),
    }),
    postPrize: builder.mutation<EnteredPrize, PrizeRequestParams>({
      query: ({ id }) => ({
        url: `/prize?id=${id}`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGetPrizeQuery, usePostPrizeMutation } = prizeAPI;

export const prizeSlice = createSlice({
  name: 'prize',
  initialState: {
    prize: {} as EnteredPrize,
    selectedPrizeType: '' as string,
  },
  reducers: {
    setSelectedPrizeType: (state, action) => {
      state.selectedPrizeType = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(prizeAPI.endpoints.getPrize.matchFulfilled, (state, action) => {
      state.prize = action.payload;
    });
    builder.addMatcher(prizeAPI.endpoints.postPrize.matchFulfilled, (state, action) => {
      state.prize = action.payload;
    });
  },
});

export const { setSelectedPrizeType } = prizeSlice.actions;

export default prizeSlice.reducer;
